export function numbersOnly(e: React.KeyboardEvent<HTMLElement>) {
  if ((e.which < 48 || (e.which > 57 && e.which < 96) || e.which > 105) && e.which !== 8) {
    e.preventDefault();
  }
}
